<template>
  <div class="section">
    <div class="swiper mySwiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide">
      <div class="section bannerClass">
        <div class="pro_wrap">
          <div class="title_wrap">
            <div class="title_1">
              产品中心
            </div>
            <img
              src="../../assets/line.png"
              class="title_line"
              alt=""
              style="width: 240px;height: 8px;margin-top:16px"
            />
            <div class="subtitle">
              PRODUCT CENTER
            </div>
            <div
              style="
                color: #ffffff;
                font-size: 14px;
                font-weight: initial;
                margin-top: 59px;
                width: 320px;
                font-family: 'Light';
              "
            ></div>
            <div
              style="margin-top: 59px; font-family: 'Light';"
              class="banner_btn"
              @click="handleMore"
            >
              了解更多
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="swiper-slide">
      <div class="section contentItem1 yj_content">
        <div class="contentTitle">
          软件产品
          <div class="little_title">
            <img src="../../assets/rect.png" alt="" />
            SOFTWARE
          </div>
        </div>
        <div class="main_content middle">
          <div class="middle_left">
            <div
              class="top_cli"
              @click="middle = 1"
              :style="{
                color: middle == 1 ? '#317df7' : '',
                borderLeft: middle == 1 ? '#317df7 4px solid' : ''
              }"
            >
              能源管理系统
            </div>
            <div
              class="top_cli"
              @click="middle = 2"
              :style="{
                color: middle == 2 ? '#317df7' : '',
                borderLeft: middle == 2 ? '#317df7 4px solid' : ''
              }"
            >
              集约能源管理系统
            </div>
            <div
              class="top_cli"
              @click="middle = 3"
              :style="{
                color: middle == 3 ? '#317df7' : '',
                borderLeft: middle == 3 ? '#317df7 4px solid' : ''
              }"
            >
              计量收费系统
            </div>
            <div
              class="top_cli"
              @click="middle = 4"
              :style="{
                color: middle == 4 ? '#317df7' : '',
                borderLeft: middle == 4 ? '#317df7 4px solid' : ''
              }"
            >
              暖通空调节能算法系统
            </div>
            <div
              class="top_cli"
              @click="middle = 5"
              :style="{
                color: middle == 5 ? '#317df7' : '',
                borderLeft: middle == 5 ? '#317df7 4px solid' : ''
              }"
            >
              动力储能回馈系统
            </div>
            <div
              class="top_cli"
              @click="middle = 6"
              :style="{
                color: middle == 6 ? '#317df7' : '',
                borderLeft: middle == 6 ? '#317df7 4px solid' : ''
              }"
            >
              智慧照明系统
            </div>
            <div
              class="top_cli"
              @click="middle = 7"
              :style="{
                color: middle == 7 ? '#317df7' : '',
                borderLeft: middle == 7 ? '#317df7 4px solid' : ''
              }"
            >
              虚拟电厂运营管理系统
            </div>
          </div>
          <div class="middle_content" v-if="middle == 1">
            <div class="middle_content_title">
              <div class="middle_p1">
                能源管理系统
                <img
                  src="../../assets/parallelogram.png"
                  alt=""
                  class="img_shadow"
                />
              </div>
            </div>
            <div class="word">
              基于小鳗管家能耗监测模块、设备监控模块、业态分析模块，运维管理模块等，实现了能耗采集、数据统计、分项分析、异常诊断、需量分析、故障告警、报表分析等管理功能，人工管控模式所存在的问题和缺陷得到了明显改善，实现精细化用能管理、能源数字化监测和智慧化运维管理。
            </div>
          </div>
          <div class="middle_content" v-if="middle == 2">
            <div>
              <div class="middle_content_title">
                <div class="middle_p1">
                  集约能源管理系统
                  <img
                    src="../../assets/parallelogram.png"
                    alt=""
                    class="img_shadow"
                  />
                </div>
              </div>
              <div class="word">
                针对集团/区域的能源管理系统，基于基础数据进行自定义指标的汇总和统计；能耗总量和经营数据，计算单位能耗产出和单位面积用能；通过大数据分析，根据月/季度/年度等时间维度进行使用状态的反馈，下发合理的项目配额/预算，用户也可根据经验进行配额配置；对集团所有项目进行横向配额使用和反馈的评估通知，协助管理优化及支撑高层决策向下满足考核指标。
              </div>
            </div>
          </div>
          <div class="middle_content" v-if="middle == 3">
            <div class="middle_content_title">
              <div class="middle_p1">
                计量收费系统
                <img
                  src="../../assets/parallelogram.png"
                  alt=""
                  class="img_shadow"
                />
              </div>
            </div>
            <div class="word">
              基于预付费智能终端，实现“先缴费后用能、远程分合闸控制、无卡自助充值”的管理模式。计量收费系统实现电能消耗的在线监测和管理，具备网络在线充值，低余额报警、欠费断电等管理手段，并支持智能水表的接入和计费管理，有效解决抄表难、收费难的问题。同时支持物业窗口缴费和移动端自助缴费，商户还能查看用电量明细、分析用能合理性，清晰掌握用电量，大大减少了收费人员的工作量、提升物业服务质量和水平。
            </div>
          </div>

          <div class="middle_content" v-if="middle == 4">
            <div class="middle_content_title">
              <div class="middle_p1">
                暖通空调节能算法系统
                <img
                  src="../../assets/parallelogram.png"
                  alt=""
                  class="img_shadow"
                />
              </div>
            </div>
            <div class="word">
              采用低功耗LORA 无线通讯和数据采集专利技术，实现中央空调集控系统的最轻量化部署；同时基于云端AI 算法和大数据处理技术，在确保室内环境舒适的前提下，对中央空调主机、水泵、冷却塔、电磁阀等设备进行安全与能效的双重监测分析，提供最优化控制策略，实现能效提升、电力需求侧响应和智能运维，帮助企业节能、降本、增效。
            </div>
          </div>
          <div class="middle_content" v-if="middle == 5">
            <div class="middle_content_title">
              <div class="middle_p1">
                动力储能回馈系统
                <img
                  src="../../assets/parallelogram.png"
                  alt=""
                  class="img_shadow"
                />
              </div>
            </div>
            <div class="word">
              采用电梯专用高性能回馈式制动单元。升降电梯在使用电梯回馈节能产品后，能有效的将电池中储存的直流电能转换成交流电能回送到电网，节电率达25%-50%。此外，由于无电阻发热元件，降低了机房的环境温度，同时也改善了电梯控制系统的运行温度，使控制系统不再死机，延长电梯使用寿命。机房可以不再使用空调等散热设备，可以节省机房空调和散热设备的耗电量，节能环保，使电梯更省电。在许多场合，节约空调耗电量往往带来更大的节电效果，是新电梯配套、旧电梯改造的首选产品。
            </div>
          </div>
          <div class="middle_content" v-if="middle == 6">
            <div class="middle_content_title">
              <div class="middle_p1">
                智慧照明系统
                <img
                  src="../../assets/parallelogram.png"
                  alt=""
                  class="img_shadow"
                />
              </div>
            </div>
            <div class="word">
              智慧照明系统能实现远程控制，根据需求可以实现远程开关照明；拥有策略管理，根据需求进行区域的开关策略控制，减少跑冒滴漏；可根据需求配置对应的场景进行快速切换（工作日/非工作日；节假日/大型活动日等）；可进行异常诊断，根据能耗和运行数据进行模型分析，及时推送异常用能告警，协助用户主动发现问题，及时解决问题，减少浪费，避免风险扩散；可进行设备管理，实现记录并分析对应照明设备的入场时间，使用时间，更换率等信息和多维协同分析。
            </div>
          </div>
          <div class="middle_content" v-if="middle == 7">
            <div class="middle_content_title">
              <div class="middle_p1">
                虚拟电厂运营管理系统
                <img
                  src="../../assets/parallelogram.png"
                  alt=""
                  class="img_shadow"
                />
              </div>
            </div>
            <div class="word">
              基于能源管理系统/暖通空调系统/智慧照明系统，利用IoT和大数据平台构架，打造了虚拟电厂运营管理系统，通过VPP协助商业运营方参与电力现货市场交易，实现分布式电源、储能微网、储能系统、可控负荷、电动汽车等分布式能源的聚合和协调控制，作为一个特殊电厂参与电力市场和电网运行、接受电网调度指令、参与需求侧响应、提供电网辅助服务。
            </div>
          </div>

          <div class="middle_right" v-if="middle == 1">
            <img src="../../assets/soft_1.png" alt="" />
          </div>

          <div class="middle_right" v-if="middle == 2">
            <img src="../../assets/soft_2.png" alt="" />
          </div>

          <div class="middle_right" v-if="middle == 3">
            <img src="../../assets/soft_3.png" alt="" />
          </div>

          <div class="middle_right" v-if="middle == 4">
            <img src="../../assets/soft_4.png" alt="" />
          </div>

          <div class="middle_right" v-if="middle == 5">
            <img src="../../assets/soft_5.png" alt="" />
          </div>

          <div class="middle_right" v-if="middle == 6">
            <img src="../../assets/soft_6.png" alt="" />
          </div>
          <div class="middle_right" v-if="middle == 7">
            <img src="../../assets/soft_7.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-slide">
      <div class="section contentItem2 yj_content">
        <div class="contentTitle white">
          硬件产品
          <div class="little_title">
            <img src="../../assets/rect.png" alt="" />
            HARDWARE
          </div>
        </div>
        <div
          class="main_content swiper_content space_between align_items_center"
        >
          <img
            src="../../assets/Btn_Left.png"
            alt=""
            class="arrow_img"
            @click="arrowClick('left')"
          />
          <div class="theSwiper">
            <el-carousel
              :autoplay="false"
              arrow="never"
              indicator-position="none"
              ref="cardShow"
            >
              <el-carousel-item
                v-for="(item, index) in swiperArr"
                :key="index"
                class="carousel_item"
              >
                <div v-if="item.imgArr.length > 1" class="carousel_imgWrap">
                  <div v-for="(i, idx) in item.imgArr" :key="idx">
                    <img :src="i" alt="" />
                  </div>
                </div>
                <div v-else>
                  <img :src="item.imgArr" alt="" class="jz_img" />
                </div>

                <div>
                  <div
                    class="middle_content_title"
                    style="color: #fff"
                  >
                    <div class="middle_p1">
                      {{ item.title }}
                      <img
                        src="../../assets/parallelogram.png"
                        alt=""
                        class="img_shadow"
                      />
                    </div>
                  </div>

                  <ul class="desc_ul">
                    <li v-for="(str, s) in item.desc" :key="s" class="flex">
                      <img src="../../assets/rect.png" alt="" />
                      <span>{{ str }}</span>
                    </li>
                  </ul>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <img
            src="../../assets/Btn_Right.png"
            alt=""
            class="arrow_img"
            @click="arrowClick('right')"
          />
        </div>
      </div>
    </div>

    </div>
    <div class="swiper-scrollbar"></div>

  </div>
  </div>
</template>

<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css"
import Swiper from 'swiper';

export default {
  name: "product",
  // components: {
  //   swiper,
  //   swiperSlide
  // },
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          //console.log(this.screenWidth);
          this.timer = false;
        }, 400);
      }
    }
  },
  data() {
    return {
      swiperOption: {
        observeParents: true,
        slidesPerView: 1, //一行显示3个
        direction: "vertical",
        mousewheel: true,
        effect: "fade",
        loop: false
      },
      startTime: undefined,
      startX: undefined,
      startY: undefined,
      screenWidth: document.body.clientWidth,
      middle: 1,

      deviceData: [],
      simpleData: [],
      feedback: [],

      dbModelList: [],
      searchList: [],
      type: -1,
      expendStatus: false,
      productModel: "",
      swiperArr: [
        {
          title: "智能电表",
          imgArr: [
            require("../../assets/-s-1.png"),
            require("../../assets/-s-2.png"),
            require("../../assets/-s-3.png"),
            require("../../assets/-s-4.png")
          ],
          desc: [
            "采用SMT工艺进行制造，工艺先进，质量可靠",
            "实现了有功、无功电能双向计量，分相计量以及计量数据的处理和存储，实现了瞬时电压、电流、有功功率、无功功率、视在功率、功率因数、电网频率等运行参数的实时采集",
            "能自动识别负载的大小，可根据设置负荷限实现对用户超负荷用电进行控制；",
            "具有物理层独立的RS485通信接口或4G无线通讯接口",
            "充分考虑了电磁兼容、数据安全、抗死机等方面的要求，功能丰富、性能稳定、质量可靠、维护方便，广泛用于办公楼、商业综合体、园区、住宅、学校、酒店、医院等场所。"
          ]
        },
        {
          title: "智能水表",
          imgArr: [
            require("../../assets/-v-1.png"),
            require("../../assets/-v-2.png"),
            require("../../assets/-v-3.png"),
            require("../../assets/-v-4.png")
          ],
          desc: [
            "采用M-bus通讯接口或NB-IoT通讯接口，信号传输稳定,，抄表方式快捷，数据更准确、可靠。",
            "单片机采用高可靠性设计，运行稳定。",
            "独有防气泡工艺，抄读数据成功率高。",
            "不受外界强磁攻击，抗干扰性能极强。 ",
            "全密封设计，防水性能好。",
            "日常工作无需供电, 使用寿命长。",
            "远传远控水表，可通过系统软件实现预付费功能,开/关阀操作。"
          ]
        },
        {
          title: "基站产品",
          imgArr: [[require("../../assets/-s-5.png")]],

          desc: [
            "导轨安装，工业级设计，超高可靠性，多种指示灯反馈设备工作状态；",
            "支持网络升级和双向连续传输数据。支持APN/VPN 接入，支持短信数据透传。支持Modbus RTU 和Modbus TCP 互转；",
            "支持4G 全网通，覆盖广、传输延迟低、稳定性高。支持手机、串口、网络等多种配置方式，串口支持多种波特率；",
            "支持多链路的边缘采集功能，支持Modbus 自动添加CRC 校验；",
            "支持4 路Socket，每条链路独立工作，支持独立20K 超大缓存；",
            " 支持多种工作模式，网络透传、MQTT 模式、HTTP 透传、短信透传。支持快速接入阿里云、百度云、OneNET、3.1 版本标准MQTT 服务器。"
          ]
        }
      ]
    };
  },
  mounted() {
    this.initSwiper()

  },
  methods: {
    initSwiper(){
      var swiper = new Swiper(".mySwiper", {
        direction: "vertical",
        effect: 'fade',
        slidesPerView: 1,
        observeParents:true,
        initialSlide: 0,
        spaceBetween: 30,
        mousewheel: {
          thresholdTime: 2000,
          thresholdDelta: 120
        },
        forceToAxis: true,
        scrollbar: {
            el: '.swiper-scrollbar',
        },
        preventClicks: false,
        preventClicksPropagation: false,
        on:{
          slideChangeTransitionEnd: function () {
            console.log(this.activeIndex); //每次切换结束时，在控制台打印现在是第几个slide
          }
        }
      });
    },
    handleMore() {
      this.$router.push("/product2");
    },
    arrowClick(val) {
      if (val == "right") {
        this.$refs.cardShow.next();
      } else {
        this.$refs.cardShow.prev();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/style/product.scss";
.contentTitle {
  font-size: 36px;
  font-family: "Regular";
  font-weight: bold;
}
.pro_wrap {
  text-align: left;
  width: 1200px;
  margin: auto;
  padding-top: 216px;
  display: flex;
  justify-content: space-between;
}
.title_1 {
  color: #ffffff;
  font-size: 60px;
  font-weight: initial;
  font-family: "PangMenZhengDao";
  letter-spacing: 6px;
}
.banner_btn {
  width: 120px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: rgba(0, 0, 0, 0);
  border: 1px solid #ffffff;
  border-radius: 16px;
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  cursor: pointer;
  color: #ffffff;
}
.contentItem1 {
  background: url("../../assets/product_bg2.png");
  background-size: 100% 100%;
}
.contentItem2 {
  background: url("../../assets/product_bg3.png");
  background-size: 100% 100%;
}

.weixin {
  display: flex;
  margin-left: 80px;
}

.weixin_it {
  display: flex;
  margin-left: 60px;
  flex-direction: column;
  text-align: center;
}

.weixin_it {
}
.item1_bottom {
  width: 1280px;
  margin: auto;
  padding-top: 20px;
  display: flex;
  justify-content: space-around;
}

.bto_left ul {
  list-style: none;
}

.bto_left ul > li {
  text-align: left;
  margin-bottom: 20px;
  color: #000;
}

.bottom_img {
  height: 400px;
  background: url("../../assets/pro/read.png");
  background-size: 100% 100%;
  margin-top: 60px;
  display: flex;
  justify-content: center;
  margin: auto;
}

.item {
  margin-top: 60px;
  width: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* .img_item {
  height: 120px;
  width: 120px;
  background: rgb(49, 125, 247);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img_item img {
  height: 60%;
  widows: 60%;
} */

.item ul {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* .item ul > li:first-child {
  color: rgb(49, 125, 247);
  font-size: 16px;
} */

.item ul > li {
  margin-top: 10px;
  color: #625a5a;
}

.item ul > li span {
  padding: 0 5px;
}
.bannerClass {
  width: 100%;
  color: #ffffff;
  background-image: url("https://file.smalleel.com/2023/08/28/16931873549Uhb5.png");
  background-position: center;
  background-size: cover;
}

/* .word {
  text-align: left;
  line-height: 30px;
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
  letter-spacing: 1px;
  color: rgb(74 64 64);
} */
.panelContent {
  padding-top: 30px;
  padding-bottom: 20px;
  width: 100%;
  margin: auto;
}

.contentItem {
  padding-top: 30px;
  padding-bottom: 20px;
  width: 1280px;
  margin: auto;
}

.middleImg {
  background: url("../../assets/pro/middle.png");
  background-size: 100% 100%;
  height: 400px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.img_one {
  text-align: right;
  color: #fff;
  font-size: 30px;
}

.img_two {
  color: #fff;
  font-size: 24px;
  letter-spacing: 2px;
}

.flex_title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  margin-top: 30px;
  color: #484848;
  font-size: 24px;
}

.content {
  display: flex;
  text-align: center;
  padding-top: 25px;
  color: #999999;
  font-size: 14px;
}

.itemCard {
  width: 200px;
  height: 339px;
  padding: 20px;
}

.itemCard:hover {
  box-shadow: 0px 20px 29px 0px rgba(20, 50, 105, 0.23);
}

.typeTitle {
  color: #ffffff;
  font-size: 24px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.dddssss {
  border-radius: 5px;
  border: 1px solid #f4f6fb;
  background-color: #ffffff;
  height: 80px;
  display: flex;
  text-align: center;
  box-shadow: 0px 0px 10px #dddddd;
  width: 1080px;
  justify-content: space-between;
}

.bbbbbbb {
  border-radius: 5px;
  border: 1px solid #f4f6fb;
  background-color: #ffffff;
  height: 80px;
  box-shadow: 0px 0px 10px #dddddd;
  width: 1080px;
  display: flex;
  justify-content: space-between;
}

.typeContent {
  color: #ffffff;
  font-size: 14px;
  text-align: center;
  padding: 10px 65px;
  line-height: 30px;
}

.feedbackCard {
  background-color: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 2px 2px 5px #dddddd;
  height: 305px;
  margin-bottom: 60px;
  border-radius: 5px;
  display: flex;
}

.middle {
  height: 29vw;
  background: linear-gradient(90deg, #ffffff, #dbe6ff);
  box-shadow: 0px 18px 40px 0px rgba(122, 127, 139, 0.1);
  opacity: 0.8;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
}
.middle_left {
  text-align: left;
  margin-top: 50px;
  width: 260px;
}
.top_cli {
  width: 100%;
  border-left: 4px solid transparent;
  height: 42px;
  line-height: 42px;
  padding-left: 40px;
  cursor: pointer;
}

.middle_content {
  width: 300px;
  height: 350px;
  margin-top: 80px;
  flex: 1;
  &_title {
    font-size: 20px;
    font-family: "Medium";
    font-weight: 500;
    color: #34383b;
    .middle_p1 {
      position: relative;

      .img_shadow {
        width: 220px;
        height: 14px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -20px;
        top: 0;
        margin: auto;
        z-index: -1;
      }
    }
  }
  .word {
    font-size: 14px;
    font-family: "Regular";
    font-weight: 400;
    color: #34383b;
    line-height: 24px;
    margin-top: 50px;
    text-indent: 28px;
    /* width: 300px; */
    text-align: left;
    padding: 0 40px;
  }
}

.middle_right {
  margin-right: 40px;
  margin-top: 60px;

  img {
    width: 480px;
    height: 360px;
  }
}
.theSwiper {
  width: 1000px;
  /* height: 500px; */
  background: #292c30;
  margin: auto;
  margin-top: 82px;
}
.arrow_img {
  width: 41px;
  height: 41px;
  cursor: pointer;
}

.yj_content {
  padding-top: 120px;
}
.desc_ul {
  text-align: left;
  flex: 1;
  margin-top: 50px;
  width: 500px;
  box-sizing: border-box;
  padding-right: 60px;
  li {
    display: flex;
    align-items: flex-start;
    span {
      display: inline-block;
      font-size: 14px;
      font-family: "Regular";
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 15px;
      margin-left: 10px;
    }
  }
}
.carousel_item {
  display: flex;
  align-items: center;
}
.carousel_imgWrap {
  display: flex;
  flex-wrap: wrap;
  margin-left: 60px;
  /* margin-top: 50px; */
  img {
    width: 180px;
    height: 180px;
  }
  img:nth-child(1) {
    margin-right: 40px;
  }
}
.jz_img {
  width: 320px;
  height: 320px;
  margin: 0px 100px 0 100px;
}
.subtitle {
  color: #ffffff;
  font-size: 24px;
  font-weight: initial;
  margin-top: 20px;
  font-family: "Regular";
}
>>> .el-carousel__container {
 height: 26vw
 /* height: 500px; */
}
</style>



// WEBPACK FOOTER //
// src/components/page/product.vue